/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Images/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import ImageViewGrid from 'DesignSystem/ImageViewGrid/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Images({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/Standard/Gallery/Content/Images"
  
}) {
let tabSelectedImagesLayoutValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.images.layout',
})
let patientImagesValueData = fromData.useDataValue({ viewPath,
context: 'patient_images',
})
let tabSelectedImagesImageSeriesIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.images.image_series_id',
})
let onImageAnalyze = fromHelpers.useOnImageAnalyze({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ImageViewGrid
  viewPath={`${viewPath}/ImageViewGrid`}
 data="tab.selected.images.layout"
 layout={tabSelectedImagesLayoutValueData}
 data="patient_images"
 patientImages={patientImagesValueData}
 data="tab.selected.images.image_series_id"
 imageSeriesId={tabSelectedImagesImageSeriesIdValueData}
 onImageAnalyze={onImageAnalyze}
/>
{children}
</React.Fragment>)
}